import { Box } from "@mui/material";
import BookmarkPlan from "components/common/Bookmark";
import Feedback from "components/common/Feedback";
import { filterPage } from "components/common/Filters/FiltersHelper";
import KeyMetrics from "components/common/KeyMetrics/KeyMetrics";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import PlanAssignment from "components/features/PlanAssignment";
import { getUserDetails } from "components/features/SME/sme.slice";
import { useTranslate } from "hooks/useTranslate";
import { cloneDeep, isEmpty, isUndefined } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setSorting } from "redux/sorting.slice";
import { tokens } from "styles/Tokens";
import {
  ABOVE_PROP_USER_TYPE,
  DEFAULT_CORP_INNCODE,
  FEEDBACK_TIMER,
  abovePropertyViewTypeProperty,
  corpViewTypes,
  sortableProperties
} from "utils/CommonConstants";
import {
  decrypt,
  formFilterRequestPayload,
  getAllMapedIdAndUsers,
  getKeyMetricsPropertiesData,
  getKeyMetricsPropertiesDataForSc,
  getTableColor,
  getplanSourceCount,
  setExtractMemberList
} from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { tableauURL } from "utils/URLConstants";
import {
  addMemberToList,
  fetchCorpDashboardPropertiesAsync,
  fetchCorpDashboardPropertiesOverviewAsync,
  fetchIndividualPropertyAsync,
  reset,
  setPropertiesListRedux
} from "../CorpUser.Slice";
import MapUserToInnCode from "../MyLists/AddUser";
import { getAllBreakupLists, getmyListType } from "../MyLists/MyLists";
import TableEdit from "../MyLists/TableEdit";
import "./CorpView.scss";
import { dashboardPropertiesHeaders, propertiesHeaders, scPropertiesHeaders } from "./TableHeadersConfig";

interface SelectedListInterface {
  id: number;
  hltId: string;
  innCode: string;
}

const PAGE_SIZE = 50;

const PropertiesData = ({ view, selectedListType, selectedList }: any) => {
  const [pageNo, setPageNo] = useState(0);
  const [propertiesDataState, setPropertiesData] = useState<any>([]);
  const [multiplansAssign, setMultiplansAssign] = useState<boolean>(false);
  const [selectAllProperties, setSelectAllProperties] = useState<boolean>(false);
  const [assignees, setAssignees] = useState<string[] | []>([]);
  const [allTeamMember, setAllTeamMember] = useState<any | []>([]);
  const [isAddUserVisible, setIsAddUserVisible] = useState<{
    isVisible: boolean;
    selectedInnCode: string;
    row: any;
    index: number;
  }>({
    isVisible: false,
    selectedInnCode: "",
    row: null,
    index: -1
  });
  const [checkInncodeUser, setCheckInncodeUser] = useState({
    shouldShow: false,
    variant: "error",
    timer: FEEDBACK_TIMER
  });
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [unCheckedMappings, setUnCheckedMappings] = useState<any>([]);
  const lobbyUserType = decrypt("salt", localStorage.getItem("lobbyUserType"));
  const propertiesList = useAppSelector((state) => state.CorpDashboard.myView.properties.list);
  const totalRecords = useAppSelector((state) => state.CorpDashboard.myView.properties.totalRecords);
  const globalFiltersforPage = useAppSelector(
    (state) =>
      state.globalFilters[
      selectedListType === "default"
        ? filterPage.dashboardDisplay
        : selectedListType === "consultant"
          ? filterPage.consultantListDisplay
          : filterPage.listDisplay
      ]
  );
  const dynamicSelectFlag = globalFiltersforPage?.dynamicSelectAll;
  const filterRequestPayload =
    view === corpViewTypes.dashboard
      ? globalFiltersforPage?.isFilterApplied
        ? globalFiltersforPage?.modifiedFilter
        : globalFiltersforPage?.defaultFilter
      : (isEmpty(globalFiltersforPage?.modifiedFilter)
        ? globalFiltersforPage?.defaultFilter
        : globalFiltersforPage?.modifiedFilter) || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);

  const overview = useAppSelector((state) => state.CorpDashboard.myView.properties.overview);
  const bookmarkedProperties = useAppSelector((state) => state.aboveProperty.bookmarkedProperties);
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);

  const tableName = "propertiesSort_" + view;
  const sorting = useAppSelector((state) => state.sortingDetails.sorting);
  const recentSortingApplied = sorting?.[tableName];
  const searchedText = useAppSelector((state) => state.CorpDashboard.searchText?.[view]);

  const dispatch = useAppDispatch();
  const [ids, setId] = useState(null);
  const navigate = useNavigate();
  const translate = useTranslate();

  const myListType = getmyListType(selectedListType, selectedList?.name);

  const fetchCorpDashboardProperties = (payload: any, callOverview: boolean = false) => {
    let payloadData = { ...payload, view: view };
    payloadData =
      view === corpViewTypes.myList
        ? { ...payloadData, myListType: myListType, myListId: selectedList?.id }
        : payloadData;
    dispatch(fetchCorpDashboardPropertiesAsync({ ...payloadData }));
  };

  const apiCall = async (page: number | undefined) => {
    let payloadData = { ...formattedFilterRequestPayload, ...dynamicSelectFlag, view: view };
    const sorting = { sort: { ...recentSortingApplied } };

    payloadData = { ...payloadData, ...sorting };

    payloadData =
      view === corpViewTypes.myList
        ? { ...payloadData, myListType: myListType, myListId: selectedList?.id }
        : { ...payloadData };
    dispatch(
      fetchCorpDashboardPropertiesOverviewAsync({
        ...payloadData
      })
    );
    const idCheck = view === corpViewTypes.myList && listCategory !== "bookmarked" ? selectedList?.id : true;
    if (idCheck) {
      const response = await dispatch(
        fetchCorpDashboardPropertiesAsync({
          ...payloadData,
          pageable: { page: page ?? pageNo, size: PAGE_SIZE },
          searchText: searchedText
        })
      );

      const mappedHltIds = response?.payload?.meta?.mappedHltIds;
      if (mappedHltIds?.length && listCategory === "consultant") {
        const userDetails = await dispatch(getUserDetails(mappedHltIds));
        setAllTeamMember(userDetails?.payload?.users || []);
      }
    }
  };

  const handleSetCheckInncodeUser = (isShow: boolean) => {
    setCheckInncodeUser({ shouldShow: isShow, variant: "error", timer: FEEDBACK_TIMER });
  };

  const fetchIndividualProperty = async (row: any, index: number) => {
    if (!row.history.length) {
      const clonedFilter = cloneDeep(formattedFilterRequestPayload);
      const clonedPropertiesDataState = cloneDeep(propertiesDataState);
      clonedFilter.inncode = [row.inncode];
      let payloadData = { ...clonedFilter, view: view };
      payloadData =
        view === corpViewTypes.myList
          ? { ...payloadData, myListType: myListType, myListId: selectedList?.id }
          : payloadData;

      const res = await dispatch(
        fetchIndividualPropertyAsync({
          ...payloadData,
          pageable: { page: pageNo, size: PAGE_SIZE }
        })
      );

      clonedPropertiesDataState[index].apiCaled = true;
      if (res.payload?.mappings) {
        const mappings = res.payload?.mappings?.map((child: any) => ({
          ...child,
          isChecked: row.isChecked
        }));
        clonedPropertiesDataState[index].history = isUndefined(clonedPropertiesDataState[index].history)
          ? mappings
          : [...clonedPropertiesDataState[index].history, ...mappings];
      }
      dispatch(setPropertiesListRedux(clonedPropertiesDataState));
    }
  };

  const fetchSummaryAndOverview = (pageNo?: number) => {
    apiCall(pageNo);
  };

  useEffect(() => {
    if (String(lobbyUserType).toLowerCase() !== ABOVE_PROP_USER_TYPE) fetchSummaryAndOverview();
  }, [filterRequestPayload]);

  const handleUserVisible = (data: any) => {
    const userData = {
      isVisible: data.isVisible,
      index: data.index,
      row: data.row,
      selectedInnCode: data.row?.innCode
    };
    const assignedData: string[] = [];
    data.row?.history?.map((history: any) => {
      if (history?.hltId) {
        assignedData.push(history.hltId);
      }
    });
    setAssignees(assignedData);

    setIsAddUserVisible(userData);
  };

  useEffect(() => {
    (async () => {
      if (pageNo > 0) {
        const sorting = { sort: { ...recentSortingApplied } };
        let payload = { ...formattedFilterRequestPayload, ...dynamicSelectFlag, ...sorting };
        payload =
          view === corpViewTypes.myList ? { ...payload, myListType: myListType, myListId: selectedList?.id } : payload;
        await dispatch(
          fetchCorpDashboardPropertiesAsync({
            ...payload,
            pageable: { page: pageNo, size: PAGE_SIZE },
            view: view,
            searchText: searchedText
          })
        );
      }
    })();
  }, [pageNo]);

  const handleSelectedAllScProperty = (e: any) => {
    const isChecked = e.target.checked;
    if (isChecked) setUnCheckedMappings([]);
    const clonedPropertiesDataState = cloneDeep(propertiesDataState);
    const newParents = clonedPropertiesDataState.map((parent: any) => ({
      ...parent,
      isChecked: !parent.inncodeMappingUserName ? false : !selectAllProperties,
      history: parent.history?.map((child: any) => ({
        ...child,
        isChecked: !selectAllProperties
      }))
    }));
    dispatch(setPropertiesListRedux(newParents));
    setSelectAllProperties(!selectAllProperties);
  };

  const handleParentChange = (e: any, parent: any, index: number) => {
    const checked = e.target.checked;
    const clonedPropertiesDataState = cloneDeep(propertiesDataState);
    clonedPropertiesDataState[index].isChecked = checked;
    if (clonedPropertiesDataState[index].history) {
      clonedPropertiesDataState[index].history = clonedPropertiesDataState[index].history.map((child: any) => ({
        ...child,
        isChecked: checked
      }));
    }

    dispatch(setPropertiesListRedux(clonedPropertiesDataState));
  };

  const handleChildChange = (parentIndex: number, childIndex: number) => {
    const newParents = cloneDeep(propertiesDataState);
    const parent = newParents[parentIndex];
    const child = parent.history[childIndex];
    child.isChecked = !child.isChecked;
    parent.isChecked = parent.history.every((child: any) => child.isChecked);
    dispatch(setPropertiesListRedux(newParents));
  };
  const getPropertyName = (property: any) => {
    if (property?.propertyName && property?.propertyName?.trim().length > 0) {
      return property?.propertyName;
    }
    return property?.inncode;
  };

  const getChildObject = (property: any, propertiesList: any) => {
    let data: any = [
      {
        content: (
          <Box
            onClick={() => {
              navigate(`/property/${property.inncode}?parentTab=Property+Plans`);
            }}
            sx={{
              textDecoration: "none",
              cursor: "pointer",
              color: tokens.Text.General.PrimaryHeadline,
              fontWeight: "700"
            }}
          >
            {getPropertyName(property)}
          </Box>
        ),
        showBold: true,
        tooltip: {}
      },
      { content: property.inncode },
      { content: property.brandName },
      {
        content: getImplementedPlanCount(view, property),
        tooltip: {
          title: view === "dashboard" ? "" : property.implementedPlansCount,
          list:
            view === "dashboard"
              ? getplanSourceCount(property.implementedPlansCountSourceBreakUp)
              : getAllBreakupLists(property?.implementedPlansCountStatusBreakUp)
        }
      },
      {
        content: view === "dashboard" ? property.managementCompany : property.brandDeadlineInitiativePlansCount,
        tooltip: getBrandOrInitPlanCountStatus(property)
      }
    ];

    if (view === "dashboard")
      data.push({
        content: property.ownerGroup
      });

    data.push({ content: property.propertyEngagement, color: getTableColor(property.propertyEngagement) });

    if (view === "myList") {
      data.push({
        content: (
          <BookmarkPlan
            aboveUserPayload={{
              isAboveUsertype: true,
              viewType: abovePropertyViewTypeProperty,
              inncode: property.inncode
            }}
            isBookmarked={bookmarkedProperties?.some((b: any) => b?.innCode === property.inncode)}
            onClickFunction={selectedList?.name === "Bookmarked Properties" ? fetchSummaryAndOverview : () => { }}
          />
        )
      });
    }

    return data;
  };

  useEffect(() => {
    if (listCategory === "consultant" && view === "myList") {
      setPropertiesData(getRowsForSc());
    }
  }, [propertiesList]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  const getImplementedPlanCount = (view: string, property: any) => {
    let implementedPlansCountText;
    if (view === "dashboard") {
      implementedPlansCountText = property.implementedPlansCount;
    } else {
      implementedPlansCountText = `${property.implementedPlansCount}`;
      if (property.implementedPlansCountStatusBreakUp?.overdue > 0) {
        implementedPlansCountText += " *";
      }
    }
    return implementedPlansCountText;
  };

  const getBrandOrInitPlanCountStatus = (property: any) => {
    let result = {};
    if (view === "dashboard") {
      if (property?.managementCompany) result = { title: property?.managementCompany };
      else result = {};
    } else {
      if (property.brandDeadlineInitiativePlansCountStatusBreakup) {
        const title = property.brandDeadlineInitiativePlansCount;
        const list = getAllBreakupLists(property?.brandDeadlineInitiativePlansCountStatusBreakup, true);

        result = { title, list };
      } else {
        result = {};
      }
    }
    return result;
  };

  function createData(
    propertyName: string,
    inncode: "string",
    inncodeMappingUserName: string,
    brandName: string,
    implementedPlansCount: any,
    implementedPlansCountStatusBreakUp: any,
    isChecked: any,
    inncodeMappingIds: any,
    item: any
  ) {
    return {
      propertyName,
      inncode,
      inncodeMappingUserName,
      brandName,
      implementedPlansCount,
      implementedPlansCountStatusBreakUp,
      history: isUndefined(item.history) ? [] : item.history,
      isChecked,
      inncodeMappingIds,
      inncodeusers: item?.inncodeusers,
      lastAssignmentDate: item?.lastAssignmentDate
    };
  }

  const getRowsForSc = () => {
    const properties = propertiesList?.map((item: any) => {
      return createData(
        item.propertyName,
        item.inncode,
        item.inncodeMappingUserName,
        item.brandName,
        item.implementedPlansCount,
        item.implementedPlansCountStatusBreakUp,
        !item.inncodeMappingUserName ? false : !isUndefined(item.isChecked) ? item.isChecked : selectAllProperties,
        item.inncodeMappingIds,
        item
      );
    });
    return properties;
  };

  const getRowData = (propertiesList: any) => {
    return propertiesList?.map((property: any) => {
      return {
        data: getChildObject(property, propertiesList)
      };
    });
  };

  const updateSelectedMappingIds = (data: any) => {
    const selectedList: any = [];
    data?.forEach((child: any) => {
      if (child.isChecked) {
        if (child.inncodeMappingIds?.length) {
          child.inncodeMappingIds.map((innCode: number, index: number) => {
            const list = {
              id: innCode,
              hltId: child.inncodeusers[index],
              innCode: child.inncode
            };
            selectedList.push(list);
          });
        } else {
          const list = {
            id: null,
            hltId: "",
            innCode: ""
          };
          selectedList.push(list);
        }
      } else if (!child.isChecked && child.history?.length) {
        child.history.forEach((subChild: any) => {
          if (subChild.isChecked) {
            const list = {
              id: subChild.mappingId,
              hltId: subChild.hltId,
              innCode: subChild.innCode
            };
            selectedList.push(list);
          }
        });
      }
    });
    return selectedList;
  };

  const getInputDetail = async (val: string) => {
    setPageNo(0);
    const sorting = { sort: { ...recentSortingApplied } };
    let payload = { ...formattedFilterRequestPayload, ...dynamicSelectFlag, ...sorting };
    payload =
      view === corpViewTypes.myList ? { ...payload, myListType: myListType, myListId: selectedList?.id } : payload;
    dispatch(
      fetchCorpDashboardPropertiesAsync({
        ...payload,
        pageable: { page: 0, size: PAGE_SIZE },
        view: view,
        searchText: val
      })
    );
  };

  const handleMemberList = async (value: any) => {
    const clonedPropertiesDataState = cloneDeep(propertiesDataState);
    const memberData = value.map((data: any) => {
      return {
        innCode: isAddUserVisible?.row?.inncode,
        hltId: data.hltId
      };
    });
    const payload = {
      id: selectedList?.id,
      mappings: memberData
    };
    const ress = await dispatch(addMemberToList(payload));
    const index = clonedPropertiesDataState.findIndex(
      (property: any) => property.propertyName === isAddUserVisible?.row?.propertyName
    );
    if (ress?.payload?.status !== responseTypes.error) {
      const mappings = ress.payload?.mappings || [];
      let newMapppings: any;
      if (isAddUserVisible?.row?.isChecked) {
        newMapppings = mappings?.map((child: any) => ({
          ...child,
          isChecked: true
        }));
      } else {
        newMapppings = mappings.map((child: any) => {
          const findmappedHistory = isAddUserVisible?.row?.history?.find(
            (mappedId: any) => mappedId?.mappingId === child?.mappingId
          );
          return { ...child, isChecked: findmappedHistory?.isChecked };
        });
        const unCheckeddMappings: any = [];
        mappings.forEach((data: any) => {
          const findmappedHistory = isAddUserVisible?.row?.history?.find(
            (mappedId: any) => mappedId?.mappingId === data?.mappingId
          );
          if (isUndefined(findmappedHistory) && !isAddUserVisible?.row.checked) {
            unCheckeddMappings.push({ hltId: data.hltId, id: data.mappingId, innCode: data.innCode });
          }
        });
        setUnCheckedMappings([...unCheckedMappings, ...unCheckeddMappings]);
      }
      if (mappings) {
        const { mappingId, hltId } = getAllMapedIdAndUsers(mappings);
        clonedPropertiesDataState[index].inncodeMappingIds = mappingId;
        clonedPropertiesDataState[index].inncodeusers = hltId;
        clonedPropertiesDataState[index].inncodeMappingUserName = hltId[0];
      }
      clonedPropertiesDataState[index].history = newMapppings;
      dispatch(setPropertiesListRedux(clonedPropertiesDataState));

      const extractedUser = setExtractMemberList(clonedPropertiesDataState);
      const userDetails: any = await dispatch(getUserDetails(extractedUser));
      const resPayload = userDetails?.payload?.users || [];
      setAllTeamMember([...resPayload, ...allTeamMember]);
      handleUserVisible({ isVisible: false, selectedInnCode: "", row: null, index: -1 });
    }
  };

  const rowSelection: SelectedListInterface[] = updateSelectedMappingIds(propertiesList);

  const handlePropertiesSorting = async (headerName: string) => {
    let header = sortableProperties[headerName];
    let sortedOrder = recentSortingApplied?.order === "asc" ? "desc" : "asc";
    let payloadData = {
      ...formattedFilterRequestPayload,
      pageable: { page: 0, size: PAGE_SIZE },
      searchText: searchedText,
      sort: {
        property: header,
        order: header === recentSortingApplied?.property ? sortedOrder : "asc"
      }
    };
    fetchCorpDashboardProperties(payloadData);
    dispatch(setSorting({ tableName: tableName, header: headerName }));
    setPageNo(0);
  };

  return (
    <div
      className={view === "dashboard" ? "dashboard-view-tab-data-component" : "corp-view-tab-data-component"}
      id="propertiesDiv"
    >
      {showError && (
        <Feedback
          form=""
          actionStatus={{ shouldShow: showError, variant: "error", timer: FEEDBACK_TIMER }}
          message={errorMessage}
          onCloseChange={() => setShowError(false)}
        />
      )}
      {listCategory === "consultant" && (
        <Feedback
          form=""
          actionStatus={checkInncodeUser}
          message="User is not mapped to some Inncodes that you have selected"
          onCloseChange={() => setCheckInncodeUser({ shouldShow: false, variant: "error", timer: FEEDBACK_TIMER })}
        />
      )}
      <KeyMetrics
        helperText={
          listCategory === "consultant" && view === "myList"
            ? "*Results displayed are for highlighted list"
            : "*Last 90 Days"
        }
        hyperLink={
          view === "dashboard"
            ? {
              link: tableauURL,
              content: (
                <Typography variant={"label"} color={tokens.Text.General.Color}>
                  Go to Tableau for full insights.
                </Typography>
              )
            }
            : {}
        }
        keyMetricsData={
          listCategory === "consultant" && view === "myList"
            ? getKeyMetricsPropertiesDataForSc(overview)
            : getKeyMetricsPropertiesData(overview)
        }
      />
      <TableEdit
        view={view}
        selectedListType={selectedListType}
        getInputDetails={(val: string) => getInputDetail(val)}
      />
      <BasicTable
        scrollableTarget="propertiesDiv"
        totalRecords={totalRecords}
        pagination={{ pageNo, setPageNo }}
        noDataMessage={translate("common.noResults")}
        data={{
          headers:
            view === "dashboard"
              ? dashboardPropertiesHeaders
              : listCategory === "consultant" && view === "myList"
                ? scPropertiesHeaders
                : propertiesHeaders,
          rows: getRowData(propertiesList),
          extraData: propertiesDataState,
          listCategory: listCategory === "consultant" && view === "myList"
        }}
        handleUserVisible={(val: any) => handleUserVisible(val)}
        fetchIndividualProperty={fetchIndividualProperty}
        selectAllProperties={selectAllProperties}
        handleSelectedAll={handleSelectedAllScProperty}
        handleParentChange={handleParentChange}
        setId={(id: any) => setId(id)}
        handleChildChange={handleChildChange}
        allTeamMember={allTeamMember}
        setMultiplansAssign={setMultiplansAssign}
        rowSelection={rowSelection}
        selectedList={selectedList}
        handleSetCheckInncodeUser={handleSetCheckInncodeUser}
        handleSorting={handlePropertiesSorting}
        view={view}
        setUnCheckedMappings={setUnCheckedMappings}
        unCheckedMappings={unCheckedMappings}
        tableName={tableName}
      />
      {isAddUserVisible.isVisible && (
        <MapUserToInnCode
          isAddUserOpen={isAddUserVisible.isVisible}
          handleClose={() => handleUserVisible({ isVisible: false, selectedInnCode: "", row: null, index: -1 })}
          selectedInnCode={isAddUserVisible?.row?.inncode}
          handleMemberList={handleMemberList}
          innCodeAssignee={assignees}
          isMultiple={true}
        />
      )}

      {multiplansAssign && (selectAllProperties || rowSelection?.length) && (
        <PlanAssignment
          open={multiplansAssign && (selectAllProperties || rowSelection?.length > 0)}
          handleCloseDialog={() => {
            setSelectAllProperties(false);
            setMultiplansAssign(false);
            setPageNo(0);
            fetchSummaryAndOverview(0);
          }}
          flow="second"
          inncodes={
            updateSelectedMappingIds(propertiesList)?.length > 0 &&
              rowSelection?.every(({ innCode }) => innCode === rowSelection[0].innCode)
              ? rowSelection[0]?.innCode
              : DEFAULT_CORP_INNCODE
          }
          scListId={selectedList?.id}
          selectAllProperties={selectAllProperties}
          unCheckedMappings={unCheckedMappings}
          users={rowSelection}
          userSelectionFlow="one"
        />
      )}
    </div>
  );
};
export default React.memo(PropertiesData);
